export default "__VITE_ASSET__DBeqgNLB__"